import styled from '@emotion/styled';
import { gettext } from '@eventbrite/i18n';
import { ToggleChip, Typography } from '@eventbrite/marmalade';
import React from 'react';
import { useSavedAutoCreatedEventFormValuesContext } from '../../../DraftEventStoreProvider';

export enum TagsTestId {
    Container = 'TagsContainer',
}

export const Tags = () => {
    const { savedAutoCreateFormValues } =
        useSavedAutoCreatedEventFormValuesContext();

    const getTagsArray = () => {
        const tags = [];
        const titleSplit = savedAutoCreateFormValues?.title?.split(' ');
        titleSplit?.forEach((item) => tags.push(item));
        if (savedAutoCreateFormValues?.venue?.name) {
            tags.push(savedAutoCreateFormValues?.venue?.name);
        }

        return tags;
    };

    const tags = getTagsArray();

    return (
        <TagsContainer
            aria-label="Event tags container"
            data-testid={TagsTestId.Container}
        >
            <Typography as="p" color="neutral-900" variant="heading-sm">
                {gettext('Tags')}
            </Typography>
            <ToggleChipsContainer>
                {tags?.map((tagText, i) => (
                    <ToggleChip
                        disabled
                        key={tagText + i}
                        aria-label={`${tagText} event tag`}
                    >
                        {tagText}
                    </ToggleChip>
                ))}
            </ToggleChipsContainer>
        </TagsContainer>
    );
};

const TagsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const ToggleChipsContainer = styled.div`
    display: flex;
    flex-flow: row wrap;
    gap: 12px;
`;
